import { atom } from "jotai";
import { allCurrenciesOption } from "library/constants";
import { SelectItem } from "library/types";
import moment from "moment";

export const filterCurrencyAtom = atom<SelectItem | null>(allCurrenciesOption);

// `text` is left empty on purpose: these defaults are evaluated at module load,
// before i18next has fetched its resource bundles, so calling i18n.t() here
// would bake the raw key into the atom. The consuming filter components
// resolve the label via useTranslation() instead, which also keeps it correct
// after a language switch.
export const filterPaymentMethodAtom = atom<SelectItem | null>({
  code: "PaymentMethod.All",
  text: "",
  value: "",
});

export const filterPaymentTypeAtom = atom<SelectItem | null>({
  code: "PaymentType.All",
  text: "",
  value: "",
});

export const reportDateAtom = atom(new Date());

export const periodFromDateAtom = atom(
  moment(moment().get("year") + "-01-01T00:00:00Z").toString(),
);
export const periodToDateAtom = atom(
  new Date(new Date().getFullYear(), new Date().getMonth() + 1, 1),
);

export const historicReportAtom = atom(false);

export const selectedBenefitsAtom = atom<Set<string>>(new Set<string>());
export const expandedBenefitsAtom = atom<Set<string>>(new Set<string>());
